import api from './../../../utils/api';
// import api from './../../../utils/mock-api';
import types from './types';
import TimeUtils from './../../../utils/TimeUtils';

const LOGGED_IN = 'Auth/loggedIn';

export default {
  async [types.actions.FETCH_WEEK_UPDATE] ({commit, getters, rootGetters, dispatch}, date) {
    console.log('Action: FETCH WEEK');
    if (getters.isFetching()) {
      return;
    }
    const loggedIn = rootGetters[LOGGED_IN]()
    if (loggedIn) {
      console.log('Action: FETCH WEEK Logged in');
      const weekId = TimeUtils.dateToWeek(date);
      try {
        commit(types.mutations.FETCHING_WEEK)
        const response = await api.getWeek(weekId)
        commit(types.mutations.RECEIVE_WEEK, response.data)
      } catch (error) {
        console.log('Action: FETCH WEEK error', error);
        // Try to auth and get again
        try {
          console.log('Action: FETCH WEEK try auth');
          await dispatch('Auth/authRefresh', null, {root: true})
          console.log('Action: FETCH WEEK try fetch again');
          commit(types.mutations.FETCHING_WEEK)
          const response = await api.getWeek(weekId)
          commit(types.mutations.RECEIVE_WEEK, response.data)
        } catch (error) {
          // still error after auth
          console.log('FETCH_WEEK error inner:', error);
          // reject()
        }
      }
    } else {
      console.log('Action: FETCH WEEK not logged in');
      throw new Error('Fetch error: not logged in');
    }
  },
  async [types.actions.FETCH_WEEK] ({getters, dispatch}, date) {
    if (!getters.hasWeek(date)) {
      return dispatch(types.actions.FETCH_WEEK_UPDATE, date);
    }
  },
  async [types.actions.CREATE_BOOKING] ({commit}, booking) {
    console.log('Action: CREATE BOOKING', booking);
    try {
      commit(types.mutations.CREATING_BOOKING);
      const response = await api.postBooking(booking);
      commit(types.mutations.BOOKING_CREATED);
      commit(types.mutations.RECEIVE_WEEK, response.data);
    } catch (error) {
      console.log('Action: CREATE BOOKING error');
      console.dir(error);
      commit(types.mutations.BOOKING_CREATE_FAILED);
      if (error.response.data.data) {
        commit(types.mutations.RECEIVE_WEEK, error.response.data.data);
      }
      throw error;
    }
  },
  async [types.actions.SAVE_EDITED_BOOKING] ({commit}, booking) {
    console.log('SAVE EDITED BOOKING', booking);
    // commit(types.mutations.SAVE_EDITED_BOOKING, booking)
    try {
      commit(types.mutations.EDITING_BOOKING);
      const response = await api.postBooking(booking);
      commit(types.mutations.BOOKING_EDITED);
      commit(types.mutations.RECEIVE_WEEK, response.data);
    } catch (error) {
      console.log('Action: EDIT BOOKING error');
      console.dir(error);
      commit(types.mutations.BOOKING_EDIT_FAILED);
      if (error.response.data.data) {
        commit(types.mutations.RECEIVE_WEEK, error.response.data.data);
      }
      throw error;
    }
  },
  async [types.actions.DELETE_BOOKING] ({commit}, booking) {
    console.log('Action: DELETE BOOKING', booking);
    try {
      commit(types.mutations.DELETING_BOOKING);
      const response = await api.deleteBooking(booking);
      commit(types.mutations.BOOKING_DELETED);
      console.log('DELETED response', response);
      commit(types.mutations.RECEIVE_WEEK, response.data);
    } catch (error) {
      console.log('Action: DELETE BOOKING error');
      console.dir(error);
      commit(types.mutations.BOOKING_DELETE_FAILED);
      throw error;
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/booking/actions.js